import {
  startGrowthBookClient,
  stopGrowthBookClient,
} from "@/core/featureFlags/growthbook.runtime";

import type { InstrumentationSubscriber } from "@/core/instrumentation/instrumentation.types";

/**
 * GrowthBook's client lifecycle as a `necessary` subscriber. The client
 * itself lives in `growthbook.runtime` — the non-React seam — so activation
 * genuinely starts it and deactivation genuinely destroys it, and
 * `FeatureFlagProvider` reads the same instance rather than constructing a
 * second one. `necessary` because feature flagging must resolve before the
 * visitor has answered anything; its exposures ride the analytics topics, so
 * they are counted only with analytics consent.
 */
export const createGrowthBookSink = (): InstrumentationSubscriber => ({
  name: "growthbook",
  requiredScope: "necessary",
  activate: () => {
    startGrowthBookClient();
  },
  deactivate: () => {
    stopGrowthBookClient();
  },
});
